/* eslint-disable no-unused-vars */

import {
  getParentEquipmentData,
  getParentEquipmentDetails
} from '../pages/parent-equipment/helper';

import { getParentSiteData, getParentSiteDetails } from '../components/parent-listing/helper';

import HSEEventSelector from '../selectors/hse/hse-event.selector';
import TasksSelector from '../selectors/tasks/tasks.selector';
import InspectionSelector from '../selectors/inspection/inspection.selector';
import CheckSelector from '../selectors/checks/check.selector';

import SitesSelector from '../selectors/sites.selector';
import StructureSelector from '../selectors/structure.selector';
import EquipmentSelector from '../selectors/equipment.selector';
import PipelineSelector from '../selectors/pipeline.selector';
import RecurringTemplateSelector from '../selectors/recurring-template.selector';
import InspectionRunSelector from '../selectors/inspection-run.selector';

import {
  searchEquipments,
  searchRts,
  searchRuns,
  searchSites,
  searchTasks,
  searchStructures,
  searchPipelines
} from '../pages/search/helper';

import { checkOldAndNewArray } from '@services/check-old-and-new-array';

const getParentEquipmentCompleteDetails = async ({ args }) => {
  const [res1, res2] = await Promise.all([
    await getParentEquipmentDetails({ ...args }),
    await getParentEquipmentData({ ...args })
  ]);
  return [res1, res2];
};

const getParentSiteCompleteDetails = async ({ args }) => {
  const [res1, res2] = await Promise.all([
    await getParentSiteDetails({ ...args }),
    await getParentSiteData({ ...args })
  ]);
  return [res1, res2];
};

const getAllTasksRecordsData = async ({ args }) => {
  const [res1, res2, res3, res4, res5] = await Promise.all([
    await TasksSelector.getTasks({ ...args }),
    await InspectionSelector.getInspections({ ...args }),
    await HSEEventSelector.getHSEEvents({ ...args }),
    await CheckSelector.getAllChecks({ ...args }),
    await EquipmentSelector.getAllEquipmentsThatIsEditedAndNewCreates({ ...args })
  ]);
  return [...res1, ...res2, ...res3, ...res4, ...res5];
};

const getSearchRelatedData = async ({ args }) => {
  const allResponse = await Promise.all([
    await TasksSelector.getTasks({ ...args }),
    await InspectionSelector.getInspections({ ...args }),
    await HSEEventSelector.getHSEEvents({ ...args }),
    await CheckSelector.getAllChecks({ ...args }),
    await SitesSelector.getSitesWithAllTasks({ ...args }),
    await EquipmentSelector.getEquipmentsWithAllTasks({ ...args, createSiteDataPoints: true }),
    await StructureSelector.getStructuresWithWO({ ...args, createSiteDataPoints: true }),
    await PipelineSelector.getPipelineWithWO({ ...args, createSiteDataPoints: true }),
    await RecurringTemplateSelector.getRecurringTemplateTasks({ ...args }),
    await InspectionRunSelector.getInspectionRuns({ ...args }),
    await EquipmentSelector.getAllEquipmentsThatIsEditedAndNewCreates({ ...args })
  ]);

  return allResponse;
};

const getSelectedSearchData = async ({ args }) => {
  const allResponse = await Promise.all([
    await searchTasks({ searched: args?.searched, data: args?.tasks, store: args?.store }), // done
    await searchSites({ searched: args?.searched, data: args?.sites, store: args?.store }), // done
    await searchEquipments({
      searched: args?.searched,
      data: args?.equipments,
      store: args?.store
    }), // done
    await searchRts({ searched: args?.searched, data: args?.rts, store: args?.store }),
    await searchRuns({ searched: args?.searched, data: args?.runs, store: args?.store }),
    await searchStructures({
      searched: args?.searched,
      data: args?.structures,
      store: args?.store
    }), // done
    await searchPipelines({ searched: args?.searched, data: args?.pipelines, store: args?.store }) // done
  ]);

  return allResponse;
};
const equipmentMobileData = ({
  equipmentPayloadData = [],
  isCheckOldAndNewArray = false,
  equipmentsMapFromCache = {},
  sitesEquipmentsMapFromCache,
  newEquipment = false,
  siteId = '',
  equipmentId = '',
  reset,
  deleteNewPSVsIds = []
}) => {
  return new Promise((resolve) => {
    if (newEquipment) {
      const equipments = equipmentPayloadData;
      const copySitesEquipmentsMapFromCache = { ...sitesEquipmentsMapFromCache };
      let equipmentIdListFromSitesMap = copySitesEquipmentsMapFromCache[siteId] || [];

      if (reset) {
        equipmentIdListFromSitesMap =
          deleteNewPSVsIds?.length > 0
            ? equipmentIdListFromSitesMap?.filter((x) => !deleteNewPSVsIds?.includes(x))
            : equipmentIdListFromSitesMap?.filter((x) => x !== equipmentId);
      } else {
        equipmentIdListFromSitesMap = [...equipmentIdListFromSitesMap, equipmentId];
      }

      const sitesEquipmentsMap = {
        ...copySitesEquipmentsMapFromCache,
        [siteId]: equipmentIdListFromSitesMap
      };

      const equipmentsMap = reset
        ? equipments?.reduce((acc, curr, currIndex) => {
            const { equipmentId } = curr;
            acc[equipmentId] = currIndex;
            return acc;
          }, {})
        : {
            ...equipmentsMapFromCache,
            [equipmentId]: equipments?.length - 1
          };

      resolve({
        equipments,
        equipmentsMap,
        sitesEquipmentsMap
      });
    } else {
      let equipments = [];
      let _equipmentPayloadData = [];
      let equipmentListThatHaveUTSection = [];

      if (isCheckOldAndNewArray) {
        const combineNewAndOldArray = checkOldAndNewArray({
          ...isCheckOldAndNewArray
        });
        equipments = combineNewAndOldArray;
        _equipmentPayloadData = combineNewAndOldArray;
      } else {
        equipments = equipmentPayloadData;
        _equipmentPayloadData = equipmentPayloadData;
      }
      const arr = [];
      const sitesEquipmentsMap = {};

      const equipmentsMap = equipments?.reduce((acc, curr, currIndex) => {
        const { siteId, equipmentId, notSHhowOnList = false, hasUTData = false } = curr;
        if (!notSHhowOnList) {
          if (!sitesEquipmentsMap[siteId]) sitesEquipmentsMap[siteId] = [];
          sitesEquipmentsMap[siteId].push(equipmentId);
        }

        if (hasUTData) {
          equipmentListThatHaveUTSection.push(equipmentId);
        }
        acc[equipmentId] = currIndex;
        return acc;
      }, {});

      for (const key in equipmentsMap) {
        const index = equipmentsMap[key];
        let data = { ..._equipmentPayloadData[equipmentsMap[key]], children: [], index };
        arr.push(data);
      }

      arr.forEach((data) => {
        if (Object.hasOwnProperty.call(equipmentsMap, data.equipmentId)) {
          const { parentId } = data;

          const parentEquipmentIndex = arr.findIndex((d) => d.equipmentId === parentId);

          if (parentEquipmentIndex) arr[parentEquipmentIndex]?.children.push(data?.index);
        }
      });

      resolve({
        equipments: arr,
        equipmentsMap,
        sitesEquipmentsMap,
        equipmentListThatHaveUTSection
      });
    }
  });
};

export {
  getParentEquipmentCompleteDetails,
  getParentSiteCompleteDetails,
  getAllTasksRecordsData,
  getSearchRelatedData,
  getSelectedSearchData,
  equipmentMobileData
};
